import * as React from 'react';
import { Id } from '../../utils/ids.js';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { WordToggleContextConsumer } from './WordToggleContext.js';
import './WordToggleOption.scss.js';

const bem = Bem.create("vai-word-toggle-option");
class WordToggleOption extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.renderWithContext = (context) => {
      const { htmlId, dataTa, tabIndex, className, disabled, value, children, ...rest } = this.props;
      const id = Id.create(htmlId, ["word toggle option"]);
      const checked = value === context.value;
      const toggleDisabled = context.disabled ?? disabled;
      return /* @__PURE__ */ React.createElement("label", {
        className: addClass(bem.block(checked ? "checked" : "unchecked", toggleDisabled ? "disabled" : "enabled"), className)
      }, children, /* @__PURE__ */ React.createElement("input", {
        id: id.toString(),
        "data-ta": dataTa,
        type: "radio",
        disabled: toggleDisabled,
        tabIndex,
        className: bem.element("input")(),
        checked: value === context.value,
        value,
        onChange: context.onChange,
        ...rest
      }));
    };
  }
  render() {
    return /* @__PURE__ */ React.createElement(WordToggleContextConsumer, null, this.renderWithContext);
  }
}
WordToggleOption.defaultProps = {
  tabIndex: 0
};

export { WordToggleOption };
